<template>
  <div class="attendancce-punch">
    <div class="mains-content">
      <div class="flex-row">
        <div v-for="(item,index) in shopListMenu" :key="index" @click="onClick(item)" class="attendancce-list">
          <img :src="item.icon" alt=""> <span class="ml10 fs16 fb">{{item.name}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      shopListMenu: [
        {name: '店员权益', url: '/dataList/equities', icon: require("../../../assets/images/equities.png")},
        {name: '店员补贴记录', url: '/dataList/subsidy', icon: require("../../../assets/images/subsidy.png")},
      ],
      list: [],
    };
  },
  methods: {
    onClick (item) {
      if (item.url) {
        this.$router.push(item.url);
      } else {
        this.$refs.accountForm.$emit("set", true)
      }
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../../assets/css/edit.less";
.attendancce-punch {
  position: relative;
  padding: 16px 16px 0;
  .attendancce-list {
    width: 200px;
    height: 100px;
    padding-left: 20px;
    display: flex;
    align-items: center;
    margin-right: 20px;
    cursor: pointer;
    border: 1px solid #efefef;
    border-radius: 10px;
  }
}
.mains-content {
  height: calc(100vh - 160px);
  background-color: #fff;
  border-radius: 10px;
  padding: 16px;
}
.item_title {
  font-size: 18px;
  font-weight: bold;
  color: #111;
  margin-bottom: 24px;
}
</style>